export const STRINGS = {
  closeButtonAriaLabel: "Close message"
};